import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { setTheOnboarderdetailsReportActions,SetUserREtrieveActions } from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";

const AuthoriedPerson = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  // useEffect(() => {
  //   if((state.clientDetailsCall.ActiveForUserProfile == 5 || state.clientDetailsCall.ActiveForUserProfile == 6) && state.ClientBranchIDs.userProfileId != null){
  //   const payload = {
  //     search: search,
  //     page_size: 20,
  //     page: dtpageindex,
  //     authorized_person: state.ClientBranchIDs.userProfileId,
  //     // authorized_person:state.ClientBranchIDs.authoriedID
  //   };
  //   dispatch(setTheOnboarderdetailsReportActions(payload));
  // }
  // }, [dtpageindex , state.clientDetailsCall
  //                                   .ActiveForUserProfile ,state.ClientBranchIDs.userProfileId]);
  useEffect(() => {
    if (
      state.ClientBranchIDs.userProfileId != undefined &&
      state.clientDetailsCall.ActiveForUserProfile == 5
    ) {
      const payload = {
        EditId: state.ClientBranchIDs.userProfileId,
      };
      dispatch(SetUserREtrieveActions(payload));
    }
  }, [state.clientDetailsCall.ActiveForUserProfile]);


   console.log(state.ClientBranchIDs.authoriedID , "userProfileId",state.ClientBranchIDs.userProfileId);
  // console.log(state.OnboaderDetailsListOut , "OnboaderDetailsListOut" , state.ClientBranchIDs.authoriedID);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: 20,
          page: 1,
          authorized_person: state.ClientBranchIDs.userProfileId,
        };

        dispatch(setTheOnboarderdetailsReportActions(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    setdtPageindex(1);
    debouncedSearch(e);
 
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const columns = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original?.first_name ? (
              <span>{row.row.original?.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original?.email ? (
              <span>{row.row.original?.email}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Designation",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original?.user_role?.role ? (
              <span>{row.row.original?.user_role?.role}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original?.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original?.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
  ];
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  return (
    <>
      <ReactTable
        // data={state.OnboaderDetailsListOut.OnboarderDetailsDATA}
        data={state.UserRetrieve.userRetrireve != null &&
          state.UserRetrieve.userRetrireve?.authorized_person != null ? 
          [state.UserRetrieve.userRetrireve?.authorized_person] : []
        }
        columns={columns}
        totalItems={state.OnboaderDetailsListOut.Total_Count}
        currentPage={currentPage}
        onChange={tochange}
        setCurrentPage={setCurrentPage}
        pagesize={pagesize}
        dtpagesize={pageSize}
        dtpageindex={dtpageindex}
        pageindex={pageindex}
        onPrevious={handlePrevious}
        onNextpage={handleNext}
        GotoEnteredPage={GotoEnteredPage}

        datacount={state.OnboaderDetailsListOut.Total_Count}
        Filter={true}
             NoFilter ={true}
      />
    </>
  );
};

export default AuthoriedPerson;
